module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"signInWithGoogle":"Über Google anmelden"},"en":{"signInWithGoogle":"Sign in with Google"}}')
  delete Component.options._Ctor
}
